<template>
  <div>
    <p class="lead">Last step! Let's get payments set up.</p>
    <p>
      Licenseland uses Stripe for payment processing, so we'll send you to Stripe to set up your payment information.
    </p>
    <p>
      Stripe will ask you a few questions so they can get the money to you. If you're not sure about your "type of
      business" you are probably a <b>sole proprietor</b> (a human being).
    </p>
    <button class="btn btn-outline-dark" @click="openStripe" :disabled="status !== 'off' && status !== 'error'">
      <i class="fab fa-stripe-s" v-show="status === 'off'"/>
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-show="status === 'pending'"></span>
      <i class="fas fa-check" v-show="status === 'on'"/>
      <i class="fas fa-times" v-show="status === 'error'"/>
      Connect with Stripe
    </button>
  </div>
</template>

<script>
const scope = 'read_write'

const scrollDown = function() {
  window.setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 50)
}

export default {
  name: 'Stripe',
  data: () => ({
    popupHeight: 1000,
    popupWidth: 800,
    status: 'off',
    windowHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || document.body.offsetHeight,
    windowWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || document.body.offsetWidth
  }),
  methods: {
    openStripe: function() {
      this.status = 'pending'
      const popup = window.open(
        `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${process.env.VUE_APP_STRIPE_CONNECT_CLIENT_ID}&scope=${scope}&redirect_uri=${process.env.VUE_APP_STRIPE_REDIRECT_URI}`,
        'stripe',
        `width=${this.popupWidth}, height=${this.popupHeight}, left=${this.windowWidth/2 - this.popupWidth/2}, top=${this.windowHeight/2 - this.popupHeight/2}`
      )
      const timer = setInterval(() => {
        if (popup.closed) {
          clearInterval(timer)
          const accessToken = localStorage.getItem('stripe:accessToken')
          if (accessToken === null) {
            console.error("No access token found in local storage from Stripe, probably because of cross-domain issues")
            this.status = 'error'
            return
          }
          this.status = 'on'
          this.$emit('input', 'on')
        }
      }, 500)
    }
  },
  watch: {
    status: scrollDown,
  }
}
</script>
